import { html, css, unsafeCSS } from 'lit';
import styles from './confirm.scss?inline';
import { ref, createRef } from 'lit/directives/ref.js';
import SotbitModal from '../default';

export default class SotbitModalConfirm extends SotbitModal {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        open: { type: Boolean, reflect: true },
        threshold: { type: Number },
    };

    constructor() {
        super();

        this._footerSlotRef = createRef();
    }

    _handleClose(e) {
        e.stopPropagation();

        if (this.hideByOverlay) {
            this.hide();
        }
    }

    _handleKeyDown(event) {
        if (this.open && event.key === 'Escape') {
            this._handleClose();
        }
    }

    _handleConfirm(event) {
        if (event.defaultPrevented) {
            return;
        }

        const eventDispatcher = this.dispatchEvent(
            new CustomEvent('confirm', {
                bubbles: true,
                composed: true,
                detail: {
                    originalEvent: event,
                },
            })
        );

        if (eventDispatcher.defaultPrevented) {
            return;
        }

        this.hide();
    }

    _handleCancel(event) {
        if (event.defaultPrevented) {
            return;
        }

        const eventDispatcher = this.dispatchEvent(
            new CustomEvent('cancel', {
                bubbles: true,
                composed: true,
                detail: {
                    originalEvent: event,
                },
            })
        );

        if (eventDispatcher.defaultPrevented) {
            return;
        }

        this.hide();
    }

    render() {
        return html` <sotbit-overlay
                part="overlay"
                class="overlay"
                fixed
                @click="${this._handleClose}"
                ${ref(this._overlayRef)}
            ></sotbit-overlay>
            <div class="wrapper" @slotchange="${this._handleSlotChange}">
                <div
                    @touchstart="${this._handleTouchStart}"
                    @touchmove="${this._handleTouchMove}"
                    @touchend="${this._handleTouchEnd}"
                    class="mobile-close"
                ></div>
                <div class="body">
                    <slot name="title"></slot>
                    <div class="content">
                        <slot></slot>
                    </div>
                </div>
                <div class="footer">
                    <div part="confirm" class="confirm" @click="${this._handleConfirm}">
                        <slot name="confirm"></slot>
                    </div>
                    <div part="cancel" class="cancel" @click="${this._handleCancel}"><slot name="cancel"></slot></div>
                </div>
            </div>`;
    }
}
